module.exports = __webpack_public_path__ + "static/media/Painted_oak_wood_grain_on_plastic_panel_2010.9b572623.webp";